<template>
  <div class="content">
    <v-app class="bg-transparent">
      <div>
        <v-main>
          <!-- ---------------LOADER PROCESANDO DATOS ---------------- -->
                    <div class="flex justify-end ">
            <v-btn
              class="mb-3 mr-3 text-white aviso-btn"
              color="green"
              @click="dialog = true"
              v-if="isSuperAdmin()"
              >Nuevo
              <v-icon class="ml-1" prepend-icon small
                >mdi-bell-plus-outline</v-icon
              >
            </v-btn>
          </div>
          <v-container fluid>
            <div class="card">
              <v-progress-linear
                v-if="cargando"
                indeterminate
                color="teal"
                height="3"
                class="mb-0"
              ></v-progress-linear>
              <div class="card-header card-header-success">
                <h4 class="card-title">
                  <v-icon dark class="mr-2">mdi-bell-outline</v-icon>Notificaciones
                </h4>
                <p class="card-category">Avisos y novedades de la plataforma</p>
              </div>
              <!-- SHOW ERROR SECTION -->
              <section v-if="errored">
                <v-alert
                  shaped
                  transition="fade-transition"
                  border="left"
                  class="mt-3 mx-3 elevation-3"
                  color="red lighten-2"
                  dark
                >
                  Lo sentimos, no es posible obtener la información en este
                  momento, por favor intente nuevamente mas tarde.
                </v-alert>
              </section>
              <v-container fluid>
                <div class="aviso-filtros">
                  <v-chip-group
                    v-model="seleccion"
                    mandatory
                    active-class="green white--text"
                    @change="actualizarEstado"
                  >
                    <v-chip
                      v-for="op in opciones"
                      :key="op.value"
                      :value="op.value"
                      small
                      >{{ op.text }}</v-chip
                    >
                  </v-chip-group>
                </div>

                <v-row class="p-3">
                  <div v-if="avisos.length === 0" class="aviso-vacio">
                    <v-icon size="56" color="grey lighten-1"
                      >mdi-bell-sleep-outline</v-icon
                    >
                    <p>No hay notificaciones</p>
                  </div>
                  <div class="aviso-wrap">
                    <div class="aviso-lista">
                      <div
                        v-for="aviso in avisos"
                        :key="aviso.avisos_id"
                        class="aviso-fila"
                        :class="{ 'aviso-fila--nuevo': !aviso.leido }"
                        @click="clickFila(aviso)"
                      >
                        <div class="aviso-fila__cuerpo">
                          <div class="aviso-fila__titulo">
                            <v-icon
                              small
                              class="aviso-fila__ico"
                              :color="aviso.leido ? 'grey lighten-1' : '#1db6c8'"
                              :aria-label="aviso.leido ? 'Leída' : 'No leída'"
                              >mdi-bullhorn-outline</v-icon
                            ><strong>{{ aviso.nombre }}</strong
                            ><span v-if="!aviso.leido" class="aviso-fila__nueva">NUEVA</span>
                          </div>
                          <div class="aviso-fila__meta">
                            {{ tiempoRelativo(fechaBase(aviso)) }}
                            <span v-if="fechaCreacion(aviso)"> · {{ fechaCreacion(aviso) }}</span>
                          </div>
                          <p
                            class="aviso-fila__desc"
                            :class="{ 'aviso-fila__desc--corto': !expandidos[aviso.avisos_id] }"
                          >
                            {{ aviso.descripcion }}
                          </p>
                          <div
                            v-if="imagenesDe(aviso).length || otrosArchivos(aviso).length"
                            class="aviso-fila__imgs"
                          >
                            <template v-for="(im, i) in imagenesDe(aviso).slice(0, 3)">
                              <button
                                v-if="!imgRota(im)"
                                :key="i"
                                type="button"
                                class="aviso-fila__img"
                                :aria-label="'Ver imagen ' + (im.nombre || '')"
                                @click.stop="abrirLightbox(aviso, i)"
                              >
                                <img
                                  :src="im.url"
                                  :alt="im.nombre || aviso.nombre"
                                  loading="lazy"
                                  @error="marcarRota(im)"
                                />
                                <span
                                  v-if="i === 2 && imagenesDe(aviso).length > 3"
                                  class="aviso-fila__mas"
                                  >+{{ imagenesDe(aviso).length - 3 }}</span
                                >
                              </button>
                              <span
                                v-else
                                :key="i"
                                class="aviso-fila__img aviso-fila__img--rota"
                                role="img"
                                aria-label="Imagen no disponible"
                                ><v-icon color="grey lighten-1">mdi-image-broken-variant</v-icon></span
                              >
                            </template>
                            <a
                              v-for="(f, i) in otrosArchivos(aviso)"
                              :key="'f' + i"
                              :href="f.url_descarga || f.url || undefined"
                              download
                              target="_blank"
                              rel="noopener"
                              class="aviso-fila__arch"
                              :class="{ 'aviso-fila__arch--off': !(f.url_descarga || f.url) }"
                              :title="'Descargar ' + f.nombre"
                              @click.stop
                            >
                              <v-icon size="30" :color="colorArchivo(f)">{{ iconoArchivo(f) }}</v-icon>
                              <span class="aviso-fila__arch-nombre">{{ f.nombre }}</span>
                              <small>{{ formatTamano(f.tamano) }}</small>
                            </a>
                          </div>
                        </div>

                        <div class="aviso-fila__der">
                          <v-tooltip v-if="!aviso.leido" left content-class="tip-solido">
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                small
                                aria-label="Marcar como leída"
                                v-on="on"
                                @click.stop="cambiarLeido(aviso.avisos_id, aviso.leido)"
                              >
                                <v-icon color="#1db6c8">mdi-check-circle-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Marcar como leída</span>
                          </v-tooltip>
                          <v-menu v-if="isSuperAdmin()" offset-y left>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                small
                                aria-label="Acciones de la notificación"
                                v-on="on"
                                @click.stop
                              >
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-btn>
                            </template>
                            <v-list dense>
                              <v-list-item @click="handleEditClick(aviso)">
                                <v-list-item-icon class="mr-3"
                                  ><v-icon small color="blue">mdi-pencil</v-icon></v-list-item-icon
                                >
                                <v-list-item-title>Editar</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="handleDeleteClick(aviso)">
                                <v-list-item-icon class="mr-3"
                                  ><v-icon small color="red">mdi-delete</v-icon></v-list-item-icon
                                >
                                <v-list-item-title>Eliminar</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </div>
                    </div>

                    <!-- Modal de Editar Aviso -->
                    <v-dialog v-model="dialogEdit" max-width="620" scrollable>
                      <v-card>
                        <div class="aviso-dlg__head">
                      <v-avatar size="44" color="white" class="mr-3">
                        <v-icon color="teal darken-1">mdi-pencil-outline</v-icon>
                      </v-avatar>
                      <div class="aviso-dlg__titulo">
                        <h2>Editar notificación</h2>
                        <span>Modificá el texto o los archivos adjuntos</span>
                      </div>
                    </div>
                        <v-card-text class="aviso-dlg__body">
                          <v-text-field
                            v-model="nombreE"
                            label="Nombre"
                            outlined
                            dense
                            color="teal"
                            :rules="reglaAviso"
                          ></v-text-field>
                          <v-textarea
                            v-model="descripcionE"
                            label="Descripción"
                            outlined
                            dense
                            rows="5"
                            auto-grow
                            color="teal"
                            :rules="reglaAviso"
                          ></v-textarea>
                          <ZonaAdjuntos
                            v-model="archivosE"
                            :existentes.sync="existentesE"
                            :max="maxArchivos"
                          />
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="px-4 py-3">
                          <v-spacer></v-spacer>
                          <v-btn text class="aviso-btn" @click="dialogEdit = false">Cancelar</v-btn>
                          <v-btn
                            color="teal darken-1"
                            depressed
                            dark
                            class="aviso-btn"
                            :loading="cargandobtn"
                            @click="editarAvisoID()"
                          >
                            Guardar cambios
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </v-row>

                <!-- Cargar mas -->
                <div v-if="avisos.length" class="aviso-mas">
                  <v-tooltip v-if="hayMas" top content-class="tip-solido">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        small
                        outlined
                        color="teal"
                        aria-label="Cargar más notificaciones"
                        :loading="cargandoMas"
                        :disabled="cargando"
                        v-on="on"
                        @click="cargarMas"
                      >
                        <v-icon>mdi-arrow-down</v-icon>
                      </v-btn>
                    </template>
                    <span>Cargar más</span>
                  </v-tooltip>
                  <span v-else class="aviso-mas__fin">No hay más notificaciones</span>
                </div>
              </v-container>

              <!-- Modal de nuevo aviso -->
              <v-dialog
                v-model="dialog"
                max-width="620"
                scrollable
                @click:outside="resetAviso()"
                @keydown.esc="dialog = false"
              >
                <v-card>
                  <div class="aviso-dlg__head">
                      <v-avatar size="44" color="white" class="mr-3">
                        <v-icon color="teal darken-1">mdi-bell-plus-outline</v-icon>
                      </v-avatar>
                      <div class="aviso-dlg__titulo">
                        <h2>Nueva notificación</h2>
                        <span>Se mostrará a los clientes elegidos apenas la crees</span>
                      </div>
                    </div>
                  <v-card-text class="aviso-dlg__body">
                    <v-text-field
                      v-model="nombre"
                      label="Nombre"
                      outlined
                      dense
                      color="teal"
                      :rules="reglaAviso"
                    ></v-text-field>
                    <v-textarea
                      v-model="descripcion"
                      label="Descripción"
                      outlined
                      dense
                      rows="5"
                      auto-grow
                      color="teal"
                      :rules="reglaAviso"
                    ></v-textarea>
                    <v-select
                      v-model="selectedCliente"
                      :items="opcionesCliente"
                      prepend-inner-icon="mdi-account-multiple-outline"
                      item-text="cliente"
                      item-value="id"
                      label="Clientes destinatarios"
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      clearable
                      outlined
                      dense
                      color="teal"
                      @change="handleSelectionChange"
                    >
                      <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggleAll">
                          <v-list-item-action>
                            <v-icon :color="allSelected ? 'teal darken-2' : ''">
                              {{
                                allSelected
                                  ? "mdi-checkbox-marked"
                                  : "mdi-checkbox-blank-outline"
                              }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Todos</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>

                    <!-- Adjuntos -->
                    <ZonaAdjuntos v-model="archivos" :max="maxArchivos" />
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="px-4 py-3">
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      class="aviso-btn"
                      @click="
                        dialog = false;
                        resetAviso();
                      "
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="teal darken-1"
                      depressed
                      dark
                      class="aviso-btn"
                      :loading="cargandobtn"
                      @click="pedirConfirmacion"
                    >
                      Crear
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Confirmación antes de crear -->
              <v-dialog v-model="dialogConfirmar" max-width="420">
                <v-card class="aviso-confirmar">
                  <v-card-title class="aviso-confirmar__titulo">
                    <v-icon color="teal darken-1" class="mr-2">mdi-bell-ring-outline</v-icon>
                    ¿Crear la notificación?
                  </v-card-title>
                  <v-card-text class="aviso-confirmar__texto">
                    Se mostrará a los clientes elegidos y se les enviará por correo.
                    <div class="aviso-confirmar__resumen">
                      <strong>{{ nombre }}</strong>
                      <span v-if="archivos.length"
                        >{{ archivos.length }}
                        {{ archivos.length === 1 ? "archivo adjunto" : "archivos adjuntos" }}</span
                      >
                    </div>
                  </v-card-text>
                  <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text class="aviso-btn" @click="dialogConfirmar = false">Volver</v-btn>
                    <v-btn
                      color="teal darken-1"
                      depressed
                      dark
                      class="aviso-btn"
                      :loading="cargandobtn"
                      @click="confirmarCrear"
                      >Sí, crear</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Visor de imagenes a pantalla completa -->
              <VisorImagenes v-model="lightbox" :aviso="lbAviso" :index="lbIdx" />

              <!-- Modal de Eliminar -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 grey lighten-2"
                    ><v-icon large color="red" class="mr-2"
                      >mdi-alert-outline</v-icon
                    >Seguro desea eliminar esta Notificacion?</v-card-title
                  >
                  <v-card-actions class="py-3">
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      outlined
                      text
                      class="aviso-btn"
                      @click="deleteConfirm"
                      >Eliminar</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      outlined
                      text
                      class="aviso-btn"
                      @click="closeDelete"
                      >Cancelar</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-container></v-main
        >
      </div>
    </v-app>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Clientes } from "../../services/clientes";
import { Notificaciones, esDemoAvisos } from "../../services/notificaciones.js";
import VisorImagenes from "../../components/Avisos/VisorImagenes.vue";
import ZonaAdjuntos from "../../components/Avisos/ZonaAdjuntos.vue";
import { tiempoRelativo } from "../../utils/tiempoRelativo.js";
import {
  fechaCreacion,
  fechaBase,
  formatTamano,
  iconoArchivo,
  colorArchivo,
  archivosDe,
  MAX_ARCHIVOS,
  ROL_ADMIN_AVISOS,
  PERMISO_ADMIN_AVISOS,
} from "../../utils/avisos.js";

export default {
  name: "Notificaciones",
  components: { VisorImagenes, ZonaAdjuntos },
  data: () => ({
    selectedAviso: null,
    //Modales
    vistaModal: false,
    dialog: false,
    dialogConfirmar: false,
    dialogEdit: false,
    dialogDelete: false,
    //Para Editar
    nombreE: "",
    descripcionE: "",
    archivosE: [], // archivos nuevos al editar
    existentesE: [], // archivos ya guardados al editar ({...archivo, quitar})

    fab: false, // Estado del Speed Dial
    showSpeedDial: [],
    aviso: null, // Aviso seleccionado
    //v-models
    id: "",
    nombre: "",
    descripcion: "",
    usuarios: "",
    user_id: "",
    nombre_mail: "",
    datosCliente: [], // Arreglo donde se guardarán los datos de clientes obtenidos de la API
    selectedCliente: [], // Variable para almacenar los clientes seleccionados en el select
    allSelected: false,
    leido: "",
    leidos: "",
    //Miniaturas / imagen ampliada
    imgRotas: {},
    expandidos: {},
    lightbox: false,
    lbAviso: null,
    lbIdx: 0,
    //Adjuntos del alta
    archivos: [],
    maxArchivos: MAX_ARCHIVOS,
    //Para funciones
    cargandobtn: false,
    mostrarRegla: false,
    editedIndex: -1,
    seleccion: "todos",
    opciones: [
      { value: "todos", text: "Todos" },
      { value: "leido", text: "Leído" },
      { value: "noLeido", text: "No Leído" },
    ],
    headers: [
      {
        text: "Nro",
        align: "start",
        sortable: false,
        value: "id",
      },

      { text: "Nombre", sorteble: false, value: "nombre" },
      { text: "Descripcion", sorteble: false, value: "descripcion" },
    ],
  }),

  computed: {
    //Estados de Avisos Store
    ...mapState("notificaciones", [
      "avisos",
      "avisosNl",
      "hayMas",
      "cargandoMas",
      "cargando",
      "read",
      "errored",
    ]),

    ...mapGetters(["roles", "permisos", "getUserId"]),

    //Para Manejar el select con la opcion de TODOS
    opcionesCliente() {
      return this.datosCliente;
    },

    icon() {
      if (this.likesAllClientes) return "mdi-close-box";
      if (this.likesSomeClientes) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    likesAllClientes() {
      return this.selectedCliente.length === this.datosCliente.length;
    },

    likesSomeClientes() {
      return this.selectedCliente.length > 0 && !this.likesAllClientes;
    },

    //Paginacion
    paginaActual: {
      get() {
        return this.$store.getters["notificaciones/pages"];
      },
    },

    existenNotificaciones() {
      return this.notificaciones.length > 0;
    },

    //Regla de campo vacio
    reglaAviso() {
      return this.mostrarRegla
        ? [(v) => !!(v && String(v).trim()) || "Campo requerido"]
        : [];
    },
  },

  created() {
     if (this.getUserId) {
        this.getAvisos();
     }
  },
  mounted() {
    this.getDatosCliente();
    this.user_id = parseInt(this.getUserId);
  },

  watch: {
    dialog(abierto) {
      // la regla de "campo requerido" arranca apagada cada vez que se abre o cierra el modal
      this.mostrarRegla = false;
      if (!abierto) this.liberarArchivos();
    },
    dialogEdit(abierto) {
      this.mostrarRegla = false;
      if (!abierto) this.liberarArchivosE();
    },
  },

  beforeDestroy() {
    this.liberarArchivos();
    this.liberarArchivosE();
  },

  //Para truncar la cantidad de elementos y no me muestre todos los datos en el card de la pagina
  filters: {
    truncate(value, maxLength) {
      if (value.length > maxLength) {
        return value.substring(0, maxLength) + "...";
      } else {
        return value;
      }
    },
  },

  methods: {
    //Acciones de Store de Avisos
    ...mapActions("notificaciones", [
      "createAviso",
      "getAvisos",
      "cargarMasAvisos",
      "getAvisosNoleidos",
      "editarAviso",
      "eliminarAviso",
      "cambiarEstadoAvisos",
      "actualizarEstadoRead",
    ]),

    fechaCreacion,
    fechaBase,
    tiempoRelativo,
    formatTamano,
    iconoArchivo,
    colorArchivo,
    archivosDe,

    // Click en la fila: marca leida y expande/contrae el texto
    clickFila(aviso) {
      if (!aviso.leido) this.cambiarLeido(aviso.avisos_id, aviso.leido);
      this.$set(this.expandidos, aviso.avisos_id, !this.expandidos[aviso.avisos_id]);
    },

    imgRota(img) {
      return !img.url || !!this.imgRotas[img.url];
    },
    marcarRota(img) {
      this.$set(this.imgRotas, img.url, true);
    },
    imagenesDe(aviso) {
      return archivosDe(aviso).filter((a) => a.es_imagen);
    },
    otrosArchivos(aviso) {
      return archivosDe(aviso).filter((a) => !a.es_imagen);
    },
    abrirLightbox(aviso, i = 0) {
      this.lbAviso = aviso;
      this.lbIdx = i;
      this.lightbox = true;
    },

    actualizarEstado() {
      let valor;
      switch (this.seleccion) {
        case "todos":
          valor = undefined;
          break;
        case "leido":
          valor = true;
          break;
        case "noLeido":
          valor = false;
          break;
        default:
          break;
      }

      this.$store.commit("notificaciones/actualizarEstadoRead", valor);
      this.$store.commit("notificaciones/setPaginate", 1);
      // al cambiar el filtro se vacia la lista y se arranca de la pagina 1
      this.$store.commit("notificaciones/setAvisos", []);
      this.$store.commit("notificaciones/setHayMas", false);
      this.getAvisos();
    },

    async cargarMas() {
      try {
        await this.cargarMasAvisos();
      } catch (error) {
        this.$toastr.e("No se pudieron cargar más notificaciones");
      }
    },

    //Funcion para Select "TODOS"
    toggleAll() {
      if (this.allSelected) {
        // Si 'Todos' está seleccionado, deselecciona todos los clientes
        this.selectedCliente = [];
        this.allSelected = false;
      } else {
        // Si 'Todos' no está seleccionado, selecciona todos los clientes
        this.selectedCliente = this.datosCliente.map((cliente) => cliente.id);
        this.allSelected = true;
      }
    },

    handleSelectionChange() {
      // Si se selecciona la opción 'Todos', selecciona todos los clientes
      if (this.selectedCliente.includes("todos")) {
        this.selectedCliente = this.datosCliente.map((cliente) => cliente.id);
        this.allSelected = true;
      } else {
        // Si no se selecciona 'Todos', deselecciona 'Todos' si está seleccionado
        if (this.allSelected) {
          this.allSelected = false;
        }
      }
    },

    //Manejo de usuario rol SuperAdmin
    isSuperAdmin() {
      if (esDemoAvisos()) return true; // modo demo: se ven los botones de admin
      // administrador de avisos: necesita el rol y el permiso propios
      return (
        this.roles.includes(ROL_ADMIN_AVISOS) &&
        this.permisos.includes(PERMISO_ADMIN_AVISOS)
      );
    },

    // Alternar la visibilidad del Speed Dial(Opciones en cards
    toggleFab(index) {
      // Cambiamos el estado de visibilidad para el aviso en el índice específico
      this.$set(this.showSpeedDial, index, !this.showSpeedDial[index]);
    },

    // Manejar el clic en el botón de edición
    handleEditClick(aviso) {
      this.seleccionarID(aviso);
      this.OpenDialog(aviso);
    },
    // Manejar el clic en el botón de eliminación
    handleDeleteClick(aviso) {
      this.deleteAviso1(aviso);
    },

    //Traer datos de cliente para Select
    async getDatosCliente() {
      try {
        const params = {};
        const response = await Clientes.getClientes(params);
        if (response.data.data == null) {
          this.datosCliente = [];
        } else {
          // Si hay datos en la respuesta, guárdalos en el arreglo 'datosCliente'
          this.datosCliente = response.data.data;
        }
      } catch (error) {
        // console.error("Error al obtener los clientes:", error);
      }
    },

    //Adjuntos: liberar las vistas previas (object URLs) y vaciar la lista
    liberarArchivos() {
      this.archivos.forEach((a) => a.preview && URL.revokeObjectURL(a.preview));
      this.archivos = [];
    },
    liberarArchivosE() {
      this.archivosE.forEach((a) => a.preview && URL.revokeObjectURL(a.preview));
      this.archivosE = [];
      this.existentesE = [];
    },

    //Para Resetear los campos del formulario de Avisos Nuevo
    resetAviso() {
      this.nombre = "";
      this.descripcion = "";
      this.selectedCliente = [];
      this.allSelected = false;
      this.liberarArchivos();
      this.mostrarRegla = false;
    },

    seleccionarID(aviso) {
      this.id = aviso.avisos_id;
    },

    //Para modal de Card
    OpenDialog(aviso) {
      (this.id = aviso.avisos_id),
        (this.dialogEdit = true),
        (this.nombreE = aviso.nombre);
      this.descripcionE = aviso.descripcion;
      this.archivosE = [];
      this.existentesE = archivosDe(aviso).map((a) => ({ ...a, quitar: false }));
    },

    //Crear Aviso
    // Valida y pide confirmación antes de crear el aviso
    pedirConfirmacion() {
      if (!this.descripcion.trim() || !this.nombre.trim()) {
        this.$toastr.e("Los campos de Notificaciones no puede estar vacía");
        this.mostrarRegla = true;
        return;
      }
      this.dialogConfirmar = true;
    },
    async confirmarCrear() {
      await this.save();
      this.dialogConfirmar = false;
    },
    async save() {
      try {
        // Verificar si la consulta está vacía
        if (!this.descripcion.trim() || !this.nombre.trim()) {
          // Si la consulta está vacía, muestra un mensaje de error o realiza alguna acción adecuada
          // console.error("Los campos de Notificaciones no puede estar vacía");
          this.$toastr.e("Los campos de Notificaciones no puede estar vacía");
          this.mostrarRegla = true;
          return;
        }
        const formData = new FormData();
        formData.append("nombre", this.nombre);
        formData.append("descripcion", this.descripcion);
        formData.append("ClientesId", this.selectedCliente);
        formData.append("descripcion", this.descripcion);
        // formData.append("NombreMail", this.nombre_mail);
        this.archivos.forEach((a) => formData.append("archivos", a.file));
        this.cargandobtn = true;

        await this.createAviso(formData);
        this.cargandobtn = false;
        this.dialog = false;
        this.$toastr.s("Notificacion Creado con Éxito!");
        this.getAvisos();
        this.getAvisosNoleidos();
        this.resetAviso();
      } catch (error) {
        this.cargandobtn = false;
        // Manejar cualquier error que ocurra durante la creación de la notificacion
        // console.error("Error creando Notificacion View:", error);
        this.$toastr.e("Error creando Notificacion");
      }
    },

    //Editar Aviso
    async editarAvisoID() {
      try {
        if (!this.descripcionE.trim() || !this.nombreE.trim()) {
          // Si la consulta está vacía, muestra un mensaje de error o realiza alguna acción adecuada
          // console.error("Los campos de Notificaciones no puede estar vacía");
          this.mostrarRegla = true;
          return;
        }
        const formData = new FormData();
        formData.append("aviso_id", this.id);
        formData.append("nombre", this.nombreE);
        formData.append("descripcion", this.descripcionE);
        this.existentesE
          .filter((e) => e.quitar)
          .forEach((e) => formData.append("eliminar", e.key));
        this.archivosE.forEach((a) => formData.append("archivos", a.file));
        this.cargandobtn = true;
        await this.$store.dispatch("notificaciones/editarAviso", formData);
        this.cargandobtn = false;
        this.$toastr.s("Notificacion editado con éxito!");
        // Mensaje de éxito
        this.dialogEdit = false;
        this.getAvisos();
        this.getAvisosNoleidos();
      } catch (error) {
        this.cargandobtn = false;
        this.$toastr.e("Error editado Notificacion!");
        // console.error("Error editando Notificacion:", error);
      }
    },

    //Camnbiar a Leido aviso
    async cambiarLeido(id, read) {
      if (!read) {
        try {
          const params = { AvisoId: id, UserId: parseInt(this.user_id) };
          const response = await Notificaciones.putCambiarEstadoAviso(params);
          this.getAvisos();
          this.getAvisosNoleidos();
          return response;
        } catch (error) {
          this.$toastr.e("No se pudo marcar la notificación como leída");
        }
      }
    },

    //Para Eliminar Aviso
    async deleteAviso1(aviso) {
      // Guarda el aviso que se va a eliminar
      this.id = aviso.avisos_id;
      // Abre el modal de confirmación
      this.dialogDelete = true;
    },

    //Eliminar aviso
    async deleteConfirm() {
      try {
        // Llama al servicio para eliminar el aviso
        await this.$store.dispatch("notificaciones/eliminarAviso", {
          id: this.id,
        });

        this.getAvisosNoleidos();
        this.$toastr.s("Notificacion Eliminado");
        // Cierra el modal de confirmación
        this.closeDelete();
      } catch (error) {
        // Maneja cualquier error que ocurra durante la eliminación
        this.$toastr.e("Error al Eliminar Notificacion");
        // console.error("Error eliminando Notificacion:", error);
      }
    },

    closeDelete() {
      // Cierra el modal de confirmación y reinicia los valores
      this.dialogDelete = false;
      this.editedItem = null;
    },
  },
};
</script>
<style>
.aviso-wrap { width: 100%; }
.aviso-lista { display: flex; flex-direction: column; gap: 8px; padding: 0 8px; }
.aviso-fila { display: flex; align-items: flex-start; gap: 14px; padding: 12px 14px; border-radius: 12px; background: #fff; border: 1px solid #eef2f4; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04); cursor: pointer; transition: box-shadow 0.15s, background 0.15s; }
.aviso-fila:hover { box-shadow: 0 3px 10px rgba(0, 0, 0, 0.09); background: #fafdff; }
.aviso-fila--nuevo { background: #f3f9fb; border-color: #dcebf0; border-left: 4px solid #1db6c8; }
.aviso-fila--nuevo:hover { background: #ecf5f8; }
.aviso-fila__img:focus-visible { outline: 2px solid #1db6c8; outline-offset: 2px; }
.aviso-fila__imgs { display: flex; gap: 6px; margin: 8px 0 2px; }
.aviso-fila__img { position: relative; display: block; flex-shrink: 0; width: 150px; height: 100px; padding: 0; border: 0; border-radius: 10px; overflow: hidden; cursor: zoom-in; background: #eee; }
.aviso-fila__img:focus-visible { outline: 2px solid #1db6c8; outline-offset: 2px; }
.aviso-fila__img img { display: block; width: 100%; height: 100%; object-fit: cover; }
.aviso-fila__arch { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; flex-shrink: 0; width: 150px; height: 100px; padding: 8px; border: 1px solid #e3e9ed; border-radius: 10px; background: #f6f8f9; text-decoration: none !important; text-align: center; }
.aviso-fila__arch:hover { background: #eef2f4; }
.aviso-fila__arch--off { pointer-events: none; opacity: 0.6; }
.aviso-fila__arch-nombre { max-width: 100%; font-size: 0.75rem; color: #37474f; line-height: 1.2; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; word-break: break-all; }
.aviso-fila__arch small { color: #8a959b; font-size: 0.68rem; }
.aviso-fila__imgs { flex-wrap: wrap; }
.aviso-fila__mas { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.5); color: #fff; font-size: 1.4rem; font-weight: 600; }
.aviso-fila__img--rota { display: flex; align-items: center; justify-content: center; background: #f5f5f5; cursor: default; }
.aviso-fila__titulo { display: flex; align-items: center; flex-wrap: wrap; gap: 2px; font-size: 0.98rem; color: #263238; }
.aviso-fila__titulo strong { font-weight: 600; }
.aviso-fila--nuevo .aviso-fila__titulo strong { font-weight: 700; }
.aviso-fila__ico { margin-right: 6px; }
.aviso-fila__meta { margin: 2px 0 6px; font-size: 0.76rem; color: #8a959b; }
.aviso-fila--nuevo .aviso-fila__meta { color: #0b7285; }
.aviso-fila__desc { margin: 0; font-size: 0.9rem; color: #455a64; white-space: pre-line; word-break: break-word; line-height: 1.45; }
.aviso-fila__desc--corto { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
.aviso-fila__cuerpo { flex: 1; min-width: 0; text-align: left; }
.aviso-fila__nueva { display: inline-block; margin-left: 8px; padding: 1px 8px; border-radius: 10px; background: #e0f2f6; color: #0b7285; font-size: 0.65rem; font-weight: 700; letter-spacing: 0.06em; vertical-align: 1px; }
.aviso-fila__der { display: flex; align-items: center; gap: 4px; flex-shrink: 0; }
.tipo-img { background: #00b1eb; }
.tipo-pdf { background: #ef7b7b; }
.tipo-doc { background: #5b8def; }
.tipo-xls { background: #43a047; }
.tipo-txt { background: #1db6c8; }
.aviso-filtros { padding: 4px 12px 12px; }
.aviso-mas { display: flex; justify-content: center; align-items: center; margin: 16px 12px 4px; padding-top: 16px; border-top: 1px solid #eee; }
.aviso-mas__fin { font-size: 0.85rem; color: #9e9e9e; }
.aviso-vacio { width: 100%; text-align: center; padding: 40px 0; color: #9e9e9e; }

.aviso-dlg__head { display: flex; align-items: center; padding: 20px; color: #fff; background: linear-gradient(135deg, #26c6da, #43a047); }
.aviso-dlg__titulo { text-align: left; }
.aviso-dlg__titulo h2 { font-size: 1.15rem; margin: 0; color: #fff; }
.aviso-dlg__titulo span { font-size: 0.78rem; opacity: 0.9; }
.aviso-dlg__body { padding: 24px 24px 8px !important; }

#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
.aviso-btn { text-transform: none !important; letter-spacing: 0 !important; font-weight: 600 !important; font-size: 0.9rem !important; }
.aviso-confirmar__titulo { font-size: 1.1rem !important; font-weight: 700; color: #263238; }
.aviso-confirmar__texto { font-size: 0.92rem; color: #455a64 !important; text-align: left; }
.aviso-confirmar__resumen { display: flex; flex-direction: column; gap: 2px; margin-top: 12px; padding: 10px 12px; border-left: 4px solid #1db6c8; border-radius: 6px; background: #f3f9fb; }
.aviso-confirmar__resumen strong { color: #263238; word-break: break-word; }
.aviso-confirmar__resumen span { font-size: 0.8rem; color: #78909c; }
</style>
